import {Box, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {closeModal, successToast, errorToast} from '../../actions';
import {updatePasswordApi} from '../../api/users.service';
import {fieldError, isFieldIvalid} from '../../utils/errorHandler';
import {useFormInput} from '../../utils/utilities';
import CustomButton from '../CustomButton';
import PasswordInput from '../PasswordInput';

const UpdatePasswordModal = changePassword => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const tempPassword = useFormInput('');
  const newPassword = useFormInput('');
  const confirmPassword = useFormInput('');

  const hideModal = () => dispatch(closeModal());

  const clearError = () => {
    if (error) {
      setError('');
    }
  };

  const onSubmit = e => {
    e.preventDefault();
    if (newPassword.value !== confirmPassword.value) {
      setError([
        {
          name: 'confirmPassword',
          message: "Password and confirm password don't match!",
        },
      ]);
    } else {
      setLoading(true);
      updatePasswordApi(
        tempPassword.value,
        newPassword.value,
        confirmPassword.value,
      )
        .then(() => {
          if (!changePassword) {
            hideModal();
          }
          dispatch(successToast('Password changed successfully!'));
          tempPassword.manuallyChange('');
          newPassword.manuallyChange('');
          confirmPassword.manuallyChange('');
        })
        .catch(e => {
          setError(e.message);
          if (e.status !== 400 && e.status !== 409) {
            dispatch(errorToast(e.message));
          }
        })
        .finally(() => setLoading(false));
    }
  };

  const confirmPassErrorMessage = () => {
    if (typeof error === 'string' && error !== '') {
      return error;
    } else if (isFieldIvalid(error, 'confirmPassword')) {
      return fieldError(error, 'confirmPassword');
    }
    return '';
  };

  return (
    <>
      {!changePassword && (
        <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
          Update temporary password
        </Typography>
      )}
      <form onSubmit={onSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems={changePassword && 'center'}>
          <Box
            display="flex"
            flexDirection="column"
            mt="2rem"
            gap="1rem"
            sx={{
              width: {
                xs: 'calc(100vw - 4rem)',
                sm: '30rem',
              },
            }}>
            <PasswordInput
              error={isFieldIvalid(error, 'oldPassword')}
              helperText={fieldError(error, 'oldPassword')}
              label="Current password"
              {...tempPassword}
              onChange={txt => {
                clearError();
                tempPassword.onChange(txt);
              }}
              sx={{marginTop: '0.5rem'}}
            />
            <PasswordInput
              error={isFieldIvalid(error, 'password')}
              helperText={fieldError(error, 'password')}
              label="New password"
              {...newPassword}
              onChange={txt => {
                clearError();
                newPassword.onChange(txt);
              }}
              sx={{marginTop: '0.5rem'}}
            />
            <PasswordInput
              error={isFieldIvalid(error, 'confirmPassword')}
              helperText={confirmPassErrorMessage()}
              label="Confirm password"
              {...confirmPassword}
              onChange={txt => {
                clearError();
                confirmPassword.onChange(txt);
              }}
              sx={{marginTop: '0.5rem', marginBottom: '1.25rem'}}
            />
            <CustomButton loading={loading} type="submit">
              Change password
            </CustomButton>
            {!changePassword && (
              <CustomButton variant="outlined" onClick={hideModal}>
                I'll do it later
              </CustomButton>
            )}
          </Box>
        </Box>
      </form>
    </>
  );
};

export default UpdatePasswordModal;
